// Formatação de dinheiro em pt-BR com moeda variável. Sem dependência de Node
// (importável em Client Components via subpath @trakd/notifications/money).

const SYMBOL_OVERRIDES: Record<string, string> = { BRL: 'R$', USD: 'US$', EUR: '€', GBP: '£' };

/** Código ISO 4217 em maiúsculas; qualquer coisa fora de 3 letras vira BRL. */
export function normalizeCurrency(code: string | null | undefined): string {
  const c = (code ?? '').trim().toUpperCase();
  return /^[A-Z]{3}$/.test(c) ? c : 'BRL';
}

export function formatMoney(
  value: number,
  currency?: string | null,
  opts: { maximumFractionDigits?: number } = {},
): string {
  const cur = normalizeCurrency(currency);
  const max = opts.maximumFractionDigits ?? 2;
  try {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: cur,
      minimumFractionDigits: Math.min(2, max),
      maximumFractionDigits: max,
    })
      .format(value)
      .replace(/\u00A0/g, ' ');
  } catch {
    return `${cur} ${value.toFixed(2)}`;
  }
}

/** Símbolo curto pra prefixo de input ("R$", "US$", "€"). Desconhecido: o código. */
export function currencySymbol(currency?: string | null): string {
  const cur = normalizeCurrency(currency);
  const known = SYMBOL_OVERRIDES[cur];
  if (known) return known;
  try {
    const part = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: cur })
      .formatToParts(1)
      .find((p) => p.type === 'currency');
    return part?.value?.trim() || cur;
  } catch {
    return cur;
  }
}
